import { useState } from "react";
import Breadcrumbs from "@/Component/Common/Breadcrumbs";
import ShareModal from "@/Component/Module/HolidayDetail/ShareModal";
import { IoMdShareAlt } from "react-icons/io";
import styles from "./ThingsToDoHeader.module.css";

export default function ThingsToDoHeader({ detail = {} }) {
  const [showShareModal, setShowShareModal] = useState(false);
  const [shareUrl, setShareUrl] = useState("");
  const title = detail.name || "Things to do";
  const heroImage = detail.heroImage || "/images/dubai-hero.jpg";
  const heroAlt = detail.heroAlt || title;
  const openShareModal = () => {
    setShareUrl(window.location.href);
    setShowShareModal(true);
  };

  return (<>
    <Breadcrumbs />
    <div className="standard-padding">
      <div className={styles.thingstodoHeaderTop}>
        <h1 className="standard-heading">{title}</h1>
        <div className={styles.thingstodoActions}>
          {/* <button
            type="button"
            className={styles.thingstodoIconBtn}
            aria-label="Map View"
          >
            <RiMap2Fill size={18} />
          </button> */}
          <button
            type="button"
            className={styles.thingstodoIconBtn}
            aria-label="Share"
            onClick={openShareModal}
          >
            <IoMdShareAlt size={20} />
          </button>
        </div>
      </div>

      <div className={styles.thingtodoheroimageWrapper}>
        <img
          src={heroImage}
          alt={heroAlt}
          className={`standard-heroimg ${styles.thingtodoheroimage}`}
        />
      </div>

      <ShareModal
        show={showShareModal}
        onHide={() => setShowShareModal(false)}
        shareUrl={shareUrl}
        title={title}
      />
    </div>
  </>);
}
